module.exports = __webpack_public_path__ + "img/sq3.60692f71.png";